import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, xs },
} = constants.breakpoints;

export const containerCss = {
  padding: "16px",

  [mediaQuery.downTo(xs)]: {
    padding: "40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "24px",
  },
};
